export default "__VITE_ASSET__B$SdYBRl__"